import React from "react";

import { _t } from "../../../languageHandler";

interface IProps {
    w?: number;
    h?: number;
    children?: React.ReactNode;
}

export default class InlineSpinner extends React.PureComponent<IProps> {
    public static defaultProps = {
        w: 16,
        h: 16,
    };

    public render(): React.ReactNode {
        return (
            <div className="mx_InlineSpinner">
                <div
                    className="mx_InlineSpinner_icon mx_Spinner_icon"
                    style={{ width: this.props.w, height: this.props.h }}
                    aria-label={_t("common.loading")}
                >
                    {this.props.children}
                </div>
            </div>
        );
    }
}
